<div class="flex-column gap-widget">
	<div class="flex-space-between w-100 gap-L">
		<div class="bg-rounded w-100 top-widget-height">
			<div *ngIf="initialized" class="flex-column flex-space-between border-box-full pad-M">
				<div class="flex-align-center flex-space-between gap-S">
					<div class="flex flex-align-center gap-XS font-MM fw-700">
						<span>{{ 'page.infrastructure.network.servers' | translate }}</span>
					</div>
				</div>
				<div class="flex-justify-end w-100">
					<div class="flex-column flex-align-end gap-XS mr-xs" style="max-width: 150px;">
						<span class="font-XL fw-500">{{ servers.length }}</span>
						<span class="grey font-XS">{{ 'page.infrastructure.network.serversLowercase' | translate }}</span>
					</div>
				</div>
			</div>
			<div class="border-box-full" *ngIf="!initialized">
				<app-dashboard-page-loader></app-dashboard-page-loader>
			</div>
		</div>
		<div class="bg-rounded w-100 top-widget-height">
			<div *ngIf="initialized" class="flex-column flex-space-between border-box-full pad-M">
				<div class="flex-align-center flex-space-between gap-S">
					<div class="flex flex-align-center gap-S font-MM fw-700">
						<span>{{ 'page.infrastructure.network.availableSpace' | translate }}</span>
						<img *ngIf="tooMuchServers" [tooltip]="'page.infrastructure.network.tooMuchServers' | translate" tooltipPosition="bottom" [tooltipOffset]="5" src="assets/icons/warning-triangle.svg">
					</div>
				</div>
				<div class="flex-justify-end w-100">
					<div class="flex-column flex-align-end gap-XS mr-xs" style="max-width: 150px;">
						<span class="font-XL fw-500" [style.color]="tooMuchServers ? '#F79939' : undefined">{{ ipPoolPercentage }}%</span>
						<span class="grey font-XS">{{ 'page.infrastructure.network.ofAddressUsed' | translate }}</span>
					</div>
				</div>
			</div>
			<div class="border-box-full" *ngIf="!initialized">
				<app-dashboard-page-loader></app-dashboard-page-loader>
			</div>
		</div>
		<div class="bg-rounded w-100 top-widget-height">
			<div *ngIf="initialized" class="flex-column flex-space-between border-box-full pad-M">
				<div class="flex-align-center flex-space-between gap-S">
					<div class="flex flex-align-center gap-XS font-MM fw-700">
						<span>Firewall</span>
					</div>
				</div>
				<div class="flex-justify-end w-100">
					<div class="flex-column flex-align-end gap-XS mr-xs" style="max-width: 150px;">
						<span class="font-XL fw-500">{{ firewall ? ('page.infrastructure.network.yes' | translate) : ('page.infrastructure.network.no' | translate) }}</span>
						<span class="grey font-XS">firewall</span>
					</div>
				</div>
			</div>
			<div class="border-box-full" *ngIf="!initialized">
				<app-dashboard-page-loader></app-dashboard-page-loader>
			</div>
		</div>
	</div>
	<div class="bg-rounded pad-M-M-0" style="padding-bottom: 5px">
		<app-network-information-form *ngIf="initialized" [network]="network"></app-network-information-form>
		<app-dashboard-page-loader *ngIf="!initialized"></app-dashboard-page-loader>
	</div>
	<div class="bg-rounded pad-M">
		<app-network-servers *ngIf="initialized" [tooMuchServers]="tooMuchServers" [network]="network" [servers]="servers"></app-network-servers>
		<app-dashboard-page-loader *ngIf="!initialized"></app-dashboard-page-loader>
	</div>
</div>
